import React, { useState } from 'react';
import Box from '../../../../components/Box';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { Helpers } from '../../../../helpers/Helpers';
import { GetAntrepoOutByIdResponseAntrepoOutVehicle, GetAntrepoOutByIdResponseAntrepoOutVehicleProduct } from '../../../../models/response/antrepoOut/GetAntrepoOutByIdResponse';
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";
import CustomTextInput from '../../../../components/CustomTextInput';
import { ConstantService } from '../../../../services/ConstantService';
import { GTipService } from '../../../../services/GTipService';
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { GetAntrepoInByIdResponse, GetAntrepoInByIdResponseAntrepoInVehicleProduct, GetAntrepoInByIdResponseData } from '../../../../models/response/antrepoIn/GetAntrepoInByIdResponse';
import { useDispatch } from 'react-redux';
import { AntrepoService } from '../../../../services/AntrepoService';
import { AntrepoAreaTypeEnum } from '../../../../models/common/Enums';
import { GetAntrepoByIdResponse } from '../../../../models/response/antrepo/GetAntrepoByIdResponse';
import CustomNumberInput from '../../../../components/CustomNumberInput';
import { GetGTipByIdResponse } from '../../../../models/response/gTip/GetGTipByIdResponse';

interface Props {
    productInformationRef: any
    antrepoOutVehicleProducts: GetAntrepoOutByIdResponseAntrepoOutVehicleProduct[]
    setAntrepoOutVehicleProducts: React.Dispatch<React.SetStateAction<GetAntrepoOutByIdResponseAntrepoOutVehicleProduct[]>>
    selectedProductType: CustomSingleSelectModel | undefined
    setSelectedProductType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    defaultProductType: CustomSingleSelectModel | undefined
    antrepoOutVehicles: GetAntrepoOutByIdResponseAntrepoOutVehicle[]
    antrepoInVehicleProducts: GetAntrepoInByIdResponseAntrepoInVehicleProduct[]
    saveAntrepoOut: (_antrepoOutVehicleProducts?: GetAntrepoOutByIdResponseAntrepoOutVehicleProduct[] | undefined) => Promise<boolean>
    stockValidations: (_outProduct: GetAntrepoOutByIdResponseAntrepoOutVehicleProduct) => Promise<boolean>
    getStockGroupedList: () => GetAntrepoInByIdResponseAntrepoInVehicleProduct[]
    antrepoIn: GetAntrepoInByIdResponseData | undefined
    isPartial: boolean
    isDisabledFromLock: boolean
}

const ProductInformation = ({
    productInformationRef,
    antrepoOutVehicleProducts,
    setAntrepoOutVehicleProducts,
    selectedProductType,
    setSelectedProductType,
    defaultProductType,
    antrepoOutVehicles,
    antrepoInVehicleProducts,
    saveAntrepoOut,
    stockValidations,
    getStockGroupedList,
    antrepoIn,
    isPartial,
    isDisabledFromLock
}: Props) => {
    const dispatch = useDispatch();
    const [potQuantity, setPotQuantity] = useState<string | undefined>('0');
    const [grossWeight, setGrossWeight] = useState<string | undefined>('0');
    const [netWeight, setNetWeight] = useState<string | undefined>('0');
    const [volume, setVolume] = useState<string | undefined>('0');
    const [area, setArea] = useState<string | undefined>('0');
    const [antrepoOutVehicleProductId, setAntrepoOutVehicleProductId] = useState<string | undefined>(undefined);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedGTip, setSelectedGTip] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedGroup, setSelectedGroup] = useState<CustomSingleSelectModel | undefined>(antrepoOutVehicles.length == 1 ? { label: antrepoOutVehicles[0].groupNo + '', value: antrepoOutVehicles[0].groupNo + '' } : undefined);
    const [selectedProductLocation, setSelectedProductLocation] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedProductKind, setSelectedProductKind] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedPotType, setSelectedPotType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [palletCount, setPalletCount] = useState<string | undefined>('0');

    const deleteItems = () => {
        saveAntrepoOut(antrepoOutVehicleProducts.filter(x => !x.isSelected))
    }

    const setItemSelected = (_id: string) => {
        setAntrepoOutVehicleProducts(antrepoOutVehicleProducts.map(function (x) {
            if (x.antrepoOutVehicleProductId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const selectAll = () => {
        var isAllSelected = antrepoOutVehicleProducts.length == antrepoOutVehicleProducts.filter(x => x.isSelected).length;

        setAntrepoOutVehicleProducts(antrepoOutVehicleProducts.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = productInformationRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const saveItem = async () => {
        if (!selectedGroup) {
            toast.error('Grup Sıra No alanını doldurunuz!');
        }
        else if (!selectedProductKind) {
            toast.error('Ürün Cinsi alanını doldurunuz!');
        }
        else if (!selectedPotType) {
            toast.error('Kap Cinsi alanını doldurunuz!');
        }
        else if (Helpers.isEmpty(potQuantity)) {
            toast.error('Kap Adet alanını doldurunuz!');
        }
        else if (Helpers.isEmpty(grossWeight)) {
            toast.error('Brüt Ağırlık (Kg) alanını doldurunuz!');
        }
        else if (Helpers.isEmpty(netWeight)) {
            toast.error('Net Ağırlık (Kg) alanını doldurunuz!');
        }
        else if (Helpers.isEmpty(volume)) {
            toast.error('Hacim (M3) alanını doldurunuz!');
        }
        else if (Helpers.isEmpty(area)) {
            toast.error('Alan (M2) alanını doldurunuz!');
        }
        else if (Helpers.toNumber(potQuantity) < 0) {
            toast.error('Kap Adet alanı negatif olamaz!');
        }
        else if (Helpers.toNumber(grossWeight) < 0) {
            toast.error('Brüt Ağırlık (Kg) alanı negatif olamaz!');
        }
        else if (Helpers.toNumber(netWeight) < 0) {
            toast.error('Net Ağırlık (Kg) alanı negatif olamaz!');
        }
        else if (Helpers.toNumber(volume) < 0) {
            toast.error('Hacim (M3) alanı negatif olamaz!');
        }
        else if (Helpers.toNumber(area) < 0) {
            toast.error('Alan (M2) alanı negatif olamaz!');
        }
        else if (netWeight && grossWeight && Helpers.toNumber(netWeight) > Helpers.toNumber(grossWeight)) {
            toast.error('Net Ağırlık (Kg) alanı Brüt Ağırlık (Kg) alanından büyük olamaz!');
        }
        // else if ((Helpers.toNumber(potQuantity) + Helpers.toNumber(grossWeight) + Helpers.toNumber(netWeight) + Helpers.toNumber(volume) + Helpers.toNumber(area)) > 0 && (Helpers.toNumber(potQuantity) == 0 || Helpers.toNumber(grossWeight) == 0 || Helpers.toNumber(netWeight) == 0 || Helpers.toNumber(volume) == 0 || Helpers.toNumber(area) == 0)) {
        //     toast.error('Girilen sayıların hepsi sıfırlanmadan herhangi bir tanesi sıfırlanamaz!');
        // }
        else {
            var inPotQuantity = Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.gTipId == selectedGTip?.value).map(x => Helpers.toNumber(x.potQuantity)));

            if (inPotQuantity > 0 && Helpers.toNumber(potQuantity) == 0) {
                toast.error('Girilen sayıların hepsi sıfırlanmadan herhangi bir tanesi sıfırlanamaz!');
                return;
            }

            var inGrossWeight = Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.gTipId == selectedGTip?.value).map(x => Helpers.toNumber(x.grossWeight)));

            if (inGrossWeight > 0 && Helpers.toNumber(grossWeight) == 0) {
                toast.error('Girilen sayıların hepsi sıfırlanmadan herhangi bir tanesi sıfırlanamaz!');
                return;
            }

            var inNetWeight = Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.gTipId == selectedGTip?.value).map(x => Helpers.toNumber(x.netWeight)));

            if (inNetWeight > 0 && Helpers.toNumber(netWeight) == 0) {
                toast.error('Girilen sayıların hepsi sıfırlanmadan herhangi bir tanesi sıfırlanamaz!');
                return;
            }

            var inVolume = Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.gTipId == selectedGTip?.value).map(x => Helpers.toNumber(x.volume)));

            if (inVolume > 0 && Helpers.toNumber(volume) == 0) {
                toast.error('Girilen sayıların hepsi sıfırlanmadan herhangi bir tanesi sıfırlanamaz!');
                return;
            }

            var inArea = Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.gTipId == selectedGTip?.value).map(x => Helpers.toNumber(x.area)));

            if (inArea > 0 && Helpers.toNumber(area) == 0) {
                toast.error('Girilen sayıların hepsi sıfırlanmadan herhangi bir tanesi sıfırlanamaz!');
                return;
            }

            var oldList: GetAntrepoOutByIdResponseAntrepoOutVehicleProduct[] = JSON.parse(JSON.stringify(antrepoOutVehicleProducts));

            var recId = Helpers.isEmpty(antrepoOutVehicleProductId) ? Helpers.generateUUID(true) : antrepoOutVehicleProductId;

            if (Helpers.isEmpty(antrepoOutVehicleProductId)) {
                var o: GetAntrepoOutByIdResponseAntrepoOutVehicleProduct = {
                    antrepoOutVehicleProductId: recId + '',
                    isSelected: false,
                    antrepoOutVehicleId: selectedGroup.additionalValue1 + '',
                    area: area,
                    grossWeight: grossWeight,
                    groupNo: selectedGroup.value,
                    gTipId: selectedGTip?.value,
                    gTipName: selectedGTip?.label,
                    netWeight: netWeight,
                    palletCount: palletCount,
                    potQuantity: potQuantity,
                    productTypeId: selectedProductType?.value,
                    productTypeName: selectedProductType?.label,
                    volume: volume,
                    isJustInformationChange: false,
                    productLocationId: selectedProductLocation?.value,
                    productLocationName: selectedProductLocation?.label,
                    productKindId: selectedProductKind?.value,
                    productKindName: selectedProductKind?.label,
                    potTypeId: selectedPotType?.value,
                    potTypeName: selectedPotType?.label,
                }

                // setAntrepoOutVehicleProducts([...antrepoOutVehicleProducts, o])
                oldList = [...oldList, o];
            }
            else {
                oldList = oldList.map(function (x) {
                    if (x.antrepoOutVehicleProductId == antrepoOutVehicleProductId) {
                        x.isSelected = false;
                        x.antrepoOutVehicleId = selectedGroup.additionalValue1 + '';
                        x.groupNo = selectedGroup.value;
                        x.area = area;
                        x.grossWeight = grossWeight;
                        x.gTipId = selectedGTip?.value;
                        x.gTipName = selectedGTip?.label;
                        x.netWeight = netWeight;
                        x.palletCount = palletCount;
                        x.potQuantity = potQuantity;
                        x.productTypeId = selectedProductType?.value;
                        x.productTypeName = selectedProductType?.label;
                        x.volume = volume;
                        x.isJustInformationChange = (potQuantity == x.potQuantity && grossWeight == x.grossWeight && netWeight == x.netWeight && volume == x.volume && area == x.area)
                        x.productLocationId = selectedProductLocation?.value;
                        x.productLocationName = selectedProductLocation?.label;
                        x.productKindId = selectedProductKind?.value;
                        x.productKindName = selectedProductKind?.label;
                        x.potTypeId = selectedPotType?.value;
                        x.potTypeName = selectedPotType?.label;
                    }

                    return x;
                });
            }

            var rec = oldList.find(x => x.antrepoOutVehicleProductId == recId);

            if (rec) {
                if (!await stockValidations(rec)) {
                    //
                }
                else if (await saveAntrepoOut(oldList)) {
                    setAntrepoOutVehicleProductId('');
                    setSelectedGTip(undefined);
                    setSelectedGroup(antrepoOutVehicles.length == 1 ? { label: antrepoOutVehicles[0].groupNo + '', value: antrepoOutVehicles[0].groupNo + '', additionalValue1: antrepoOutVehicles[0].antrepoOutVehicleId } : undefined);
                    setSelectedProductType(defaultProductType);
                    setSelectedProductLocation(undefined);
                    setSelectedPotType(undefined);
                    setSelectedProductKind(undefined);
                    setPotQuantity('0');
                    setGrossWeight('0');
                    setNetWeight('0');
                    setPalletCount('0');
                    setVolume('0');
                    setArea('0');
                    setIsOpen(false);
                    scrollTo();
                }
            }
        }
    }

    const onGTipSelect = (_selectedValue: CustomSingleSelectModel) => {
        if (Helpers.isEmpty(antrepoOutVehicleProductId) && antrepoInVehicleProducts.filter(x => x.gTipId == _selectedValue.value).length == 1) {
            var o = antrepoInVehicleProducts.filter(x => x.gTipId == _selectedValue.value)[0];

            setSelectedGTip(o.gTipId && o.gTipName ? { label: o.gTipName, value: o.gTipId } : undefined);
            setSelectedProductType(o.productTypeId && o.productTypeName ? { label: o.productTypeName, value: o.productTypeId } : undefined);
            setSelectedProductLocation(o.productLocationId && o.productLocationName ? { label: o.productLocationName, value: o.productLocationId } : undefined);
            setSelectedPotType(o.potTypeId && o.potTypeName ? { label: o.potTypeName, value: o.potTypeId } : undefined);
            setSelectedProductKind(o.productKindId && o.productKindName ? { label: o.productKindName, value: o.productKindId } : undefined);
        }
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            setSelectedGroup(antrepoOutVehicles.length == 1
                ? { label: antrepoOutVehicles[0].groupNo + '', value: antrepoOutVehicles[0].groupNo + '', additionalValue1: antrepoOutVehicles[0].antrepoOutVehicleId }
                : { label: antrepoOutVehicles.filter(x => x.isSelected)[0].groupNo + '', value: antrepoOutVehicles.filter(x => x.isSelected)[0].groupNo + '', additionalValue1: antrepoOutVehicles.filter(x => x.isSelected)[0].antrepoOutVehicleId });

            if (isPartial) {
                if (antrepoInVehicleProducts.length == 1) {
                    var o = antrepoInVehicleProducts[0];
                    setSelectedGTip(o.gTipId && o.gTipName ? { label: o.gTipName, value: o.gTipId } : undefined);
                    setSelectedProductType(o.productTypeId && o.productTypeName ? { label: o.productTypeName, value: o.productTypeId } : undefined);
                    setSelectedProductLocation(o.productLocationId && o.productLocationName ? { label: o.productLocationName, value: o.productLocationId } : undefined);
                    setSelectedPotType(o.potTypeId && o.potTypeName ? { label: o.potTypeName, value: o.potTypeId } : undefined);
                    setSelectedProductKind(o.productKindId && o.productKindName ? { label: o.productKindName, value: o.productKindId } : undefined);
                }
            }

            scrollTo();
            return;
        }

        setAntrepoOutVehicleProductId('');
        setSelectedGTip(undefined);
        setSelectedGroup(antrepoOutVehicles.length == 1 ? { label: antrepoOutVehicles[0].groupNo + '', value: antrepoOutVehicles[0].groupNo + '', additionalValue1: antrepoOutVehicles[0].antrepoOutVehicleId } : undefined);
        setSelectedProductType(defaultProductType);
        setSelectedProductLocation(undefined);
        setSelectedPotType(undefined);
        setSelectedProductKind(undefined);
        setPotQuantity('0');
        setGrossWeight('0');
        setNetWeight('0');
        setPalletCount('0');
        setVolume('0');
        setArea('0');
        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = antrepoOutVehicleProducts.filter(x => x.isSelected)[0];

        setAntrepoOutVehicleProductId(o.antrepoOutVehicleProductId);
        setSelectedGTip(o.gTipId && o.gTipName ? { label: o.gTipName, value: o.gTipId } : undefined);
        setSelectedGroup(o.groupNo ? { label: o.groupNo, value: o.groupNo, additionalValue1: o.antrepoOutVehicleProductId } : undefined)
        setSelectedProductType(o.productTypeId && o.productTypeName ? { label: o.productTypeName, value: o.productTypeId } : undefined);
        setSelectedProductLocation(o.productLocationId && o.productLocationName ? { label: o.productLocationName, value: o.productLocationId } : undefined);
        setSelectedPotType(o.potTypeId && o.potTypeName ? { label: o.potTypeName, value: o.potTypeId } : undefined);
        setSelectedProductKind(o.productKindId && o.productKindName ? { label: o.productKindName, value: o.productKindId } : undefined);
        setPotQuantity(o.potQuantity);
        setGrossWeight(o.grossWeight);
        setNetWeight(o.netWeight);
        setPalletCount(o.palletCount);
        setVolume(o.volume);
        setArea(o.area);
        setIsOpen(true);
        scrollTo();
    }

    const getProductLocationList = async () => {
        try {
            if (antrepoIn && antrepoIn.antrepoId) {
                var response: GetAntrepoByIdResponse = await AntrepoService.getAntrepoById(antrepoIn.antrepoId);
                if (!response.isSuccess) {
                    toast.error(response.message)

                    return {
                        isSuccess: true,
                        data: []
                    };
                }

                return {
                    isSuccess: true,
                    data: response.data.antrepoAreas.filter(x => x.antrepoAreaTypeKey == AntrepoAreaTypeEnum.STOKLAMA)
                };
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }

        return {
            isSuccess: true,
            data: []
        };
    }

    return (
        <div className='containerPart' ref={productInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Ürün Bilgileri</h4>
                    <h4 className="mb-10 text-black">Çıkış</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Grup Sıra No</label>

                                        <CustomSingleSelect
                                            onChange={setSelectedGroup}
                                            selectedValue={selectedGroup}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: antrepoOutVehicles.map(function (x) {
                                                        var obj: CustomSingleSelectModel | undefined = {
                                                            label: x.groupNo + '',
                                                            value: x.groupNo + '',
                                                            additionalValue1: x.antrepoOutVehicleId
                                                        }

                                                        return obj;
                                                    })
                                                }
                                            }}
                                            labelName='label'
                                            valueName='value'
                                            additionalValue1Name="additionalValue1"
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">GTip No</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedGTip}
                                            onChange={(selectedValue) => {
                                                if (selectedValue) {
                                                    while (selectedValue.label.startsWith('-'))
                                                        selectedValue.label = selectedValue.label.slice(1);
                                                }

                                                setSelectedGTip(selectedValue);

                                                if (selectedValue)
                                                    onGTipSelect(selectedValue);
                                            }}
                                            onMenuOpen={(searchTerm) => GTipService.getGTipList(0, 100, searchTerm)}
                                            labelName='gTip1'
                                            label2Name='gTipDesc'
                                            valueName='gTipId'
                                            additionalValue1Name='gTipDesc'
                                            isPaging
                                            isOrdering={false}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Ürün Cinsi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedProductKind}
                                            onChange={setSelectedProductKind}
                                            onMenuOpen={() => ConstantService.getConstantList('PRODUCT_KIND', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ürün Özelliği</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedProductType}
                                            onChange={setSelectedProductType}
                                            onMenuOpen={() => ConstantService.getConstantList('PRODUCT_TYPE', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Kap Cinsi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedPotType}
                                            onChange={setSelectedPotType}
                                            insertable={{
                                                onSubmit: { code: 'POT_TYPE' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('POT_TYPE', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Kap Adet</label>
                                        <CustomNumberInput value={potQuantity} setValue={setPotQuantity} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Brüt Ağırlık (Kg)</label>
                                        <CustomNumberInput value={grossWeight} setValue={setGrossWeight} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Net Ağırlık (Kg)</label>
                                        <CustomNumberInput value={netWeight} setValue={setNetWeight} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Hacim (M3)</label>
                                        <CustomNumberInput value={volume} setValue={setVolume} />
                                    </div>
                                </div>

                                <div className='row mt-5'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Alan (M2)</label>
                                        <CustomNumberInput value={area} setValue={setArea} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Palet Adet</label>

                                        <CustomNumberInput value={palletCount} setValue={setPalletCount} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ürün Lokasyonu</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedProductLocation}
                                            onChange={setSelectedProductLocation}
                                            onMenuOpen={async () => await getProductLocationList()}
                                            labelName='name'
                                            valueName='antrepoAreaId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    {
                        !isDisabledFromLock && (
                            <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                                <Box onClick={antrepoOutVehicles.filter(a => a.isSelected).length == 1 ? cancelAdding : undefined} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} opacity={antrepoOutVehicles.filter(a => a.isSelected).length == 1 ? "1" : "0.5"} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                                    </Box>
                                </Box>

                                <Box onClick={antrepoOutVehicleProducts.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={antrepoOutVehicleProducts.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className="text-white fa fa-edit" />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                                    </Box>
                                </Box>

                                <Box onClick={antrepoOutVehicleProducts.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={antrepoOutVehicleProducts.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className="text-white fa fa-trash" />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                                    </Box>
                                </Box>
                            </Box>
                        )
                    }

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                {
                                                    !isDisabledFromLock && (
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={selectAll} className='form-check-input' type='checkbox' checked={antrepoOutVehicleProducts.filter(x => x.isSelected).length > 0 && antrepoOutVehicleProducts.filter(x => x.isSelected).length == antrepoOutVehicleProducts.length} />
                                                            </label>
                                                        </div>
                                                    )
                                                }
                                            </th>
                                            <th style={{ width: 1 }}>Grup Sıra No</th>
                                            <th>GTip No</th>
                                            <th>Ürün Cinsi</th>
                                            <th>Ürün Özelliği</th>
                                            <th>Ürün Lokasyonu</th>
                                            <th>Kap Cinsi</th>
                                            <th>Palet Adet</th>
                                            <th style={{ width: 1 }}>Kap Adet</th>
                                            <th style={{ width: 1 }}>Brüt Ağırlık (Kg)</th>
                                            <th style={{ width: 1 }}>Net Ağırlık (Kg)</th>
                                            <th style={{ width: 1 }}>Hacim (M3)</th>
                                            <th style={{ width: 1 }}>Alan (M2)</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            antrepoOutVehicleProducts.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            antrepoOutVehicleProducts.sort(function (a, b) {
                                                return Helpers.toNumber(a.groupNo) - Helpers.toNumber(b.groupNo);
                                            }).map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        {
                                                            !isDisabledFromLock && (
                                                                <div className='d-flex'>
                                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                        <input onChange={() => setItemSelected(item.antrepoOutVehicleProductId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                    </label>
                                                                </div>
                                                            )
                                                        }
                                                    </td>
                                                    <td>{item.groupNo}</td>
                                                    <td>{item.gTipName}</td>
                                                    <td>{item.productKindName}</td>
                                                    <td>{item.productTypeName}</td>
                                                    <td>{item.productLocationName}</td>
                                                    <td>{item.potTypeName}</td>
                                                    <td className='custom-text-right'>{item.palletCount}</td>
                                                    <td className='custom-text-right'>{item.potQuantity}</td>
                                                    <td className='custom-text-right'>{item.grossWeight}</td>
                                                    <td className='custom-text-right'>{item.netWeight}</td>
                                                    <td className='custom-text-right'>{item.volume}</td>
                                                    <td className='custom-text-right'>{item.area}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                    {
                                        antrepoOutVehicleProducts.length > 0 && (
                                            <tfoot className='text-gray-600 fw-bold'>
                                                <tr style={{ fontWeight: 'bold', color: 'red', borderTop: '1px solid rgba(0, 0, 0, 0.40)' }}>
                                                    <td className="custom-text-right" colSpan={7}>Toplam</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoOutVehicleProducts.filter(x => x.palletCount).map(x => Helpers.toNumber(x.palletCount)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoOutVehicleProducts.filter(x => x.potQuantity).map(x => Helpers.toNumber(x.potQuantity)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoOutVehicleProducts.filter(x => x.grossWeight).map(x => Helpers.toNumber(x.grossWeight)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoOutVehicleProducts.filter(x => x.netWeight).map(x => Helpers.toNumber(x.netWeight)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoOutVehicleProducts.filter(x => x.volume).map(x => Helpers.toNumber(x.volume)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoOutVehicleProducts.filter(x => x.area).map(x => Helpers.toNumber(x.area)))}</td>
                                                </tr>
                                            </tfoot>
                                        )
                                    }
                                </table>
                            </div>
                        </div>
                    </div>

                    <h4 className="mb-10 mt-10 text-black">Stok</h4>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>Depoda Kaldığı Gün</th>
                                            <th>GTip No</th>
                                            <th>Ürün Cinsi</th>
                                            <th>Ürün Özelliği</th>
                                            <th>Kap Cinsi</th>
                                            <th style={{ width: 1 }}>Kap Adet</th>
                                            <th style={{ width: 1 }}>Brüt Ağırlık (Kg)</th>
                                            <th style={{ width: 1 }}>Net Ağırlık (Kg)</th>
                                            <th style={{ width: 1 }}>Hacim (M3)</th>
                                            <th style={{ width: 1 }}>Alan (M2)</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            antrepoInVehicleProducts.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0).length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            getStockGroupedList().map((item, index) =>
                                                <tr>
                                                    <td style={{ fontWeight: 'bold', color: 'red', }} className='text-center'>{item.daysInStorage}</td>
                                                    <td>{item.gTipName}</td>
                                                    <td>{item.productKindName}</td>
                                                    <td>{item.productTypeName}</td>
                                                    <td>{item.potTypeName}</td>
                                                    <td className='custom-text-right'>{item.stockPotQuantity}</td>
                                                    <td className='custom-text-right'>{item.stockGrossWeight}</td>
                                                    <td className='custom-text-right'>{item.stockNetWeight}</td>
                                                    <td className='custom-text-right'>{item.stockVolume}</td>
                                                    <td className='custom-text-right'>{item.stockArea}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                    {
                                        antrepoInVehicleProducts.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0).length > 0 && (
                                            <tfoot className='text-gray-600 fw-bold'>
                                                <tr style={{ fontWeight: 'bold', color: 'red', borderTop: '1px solid rgba(0, 0, 0, 0.40)' }}>
                                                    <td className="custom-text-right" colSpan={5}>Toplam</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.stockPotQuantity).map(x => Helpers.toNumber(x.stockPotQuantity)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.stockGrossWeight).map(x => Helpers.toNumber(x.stockGrossWeight)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.stockNetWeight).map(x => Helpers.toNumber(x.stockNetWeight)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.stockVolume).map(x => Helpers.toNumber(x.stockVolume)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.stockArea).map(x => Helpers.toNumber(x.stockArea)))}</td>
                                                </tr>
                                            </tfoot>
                                        )
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default ProductInformation;